import { AfterViewInit, ChangeDetectorRef, EventEmitter, QueryList } from '@angular/core';
import { merge } from 'rxjs';
import { FilterComponentBase, FilterKeys } from '../filters/filters';
import { ServiceType } from '../filters/airport-filters';
import { FuelType } from '../../business/models/business-fuel.model';
import { SearchQuery } from '../models/search-query.model';
import { ApproachType } from '../../airport/models/approach-type.model';
import { GlobalSettingsService } from '../../shared/services/global-settings.service';
import { AnalyticsService } from '../../airport/service/google-analytics-4.service';
var AirportFilterListComponent = /** @class */ (function () {
    function AirportFilterListComponent(_cdRef, _globalSettingsService, _analyticsService) {
        this._cdRef = _cdRef;
        this._globalSettingsService = _globalSettingsService;
        this._analyticsService = _analyticsService;
        this.filtersChange = new EventEmitter();
        this.numSelectedChange = new EventEmitter();
        this.publicUseChanged = new EventEmitter();
        this.FilterKeys = FilterKeys;
        this.prevNumSelected = null;
    }
    AirportFilterListComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        merge.apply(void 0, this.filterComponents.map(function (f) { return f.change.asObservable(); })).subscribe(function () {
            _this.filtersChange.emit();
            _this.updateNumSelected();
        });
        setTimeout(function () {
            _this.updateNumSelected();
            _this.filtersChange.emit();
        }, 300);
        this._analyticsService.pageView('airport_landingpage_airport', 'Airport Landing Page filters');
    };
    AirportFilterListComponent.prototype.onPublicUseChanged = function () {
        this.publicUseChanged.emit(this.query.getFilter(FilterKeys.PublicUse).enabled);
    };
    AirportFilterListComponent.prototype.updateNumSelected = function () {
        var numSelected = this.getNumSelected();
        if (numSelected !== this.prevNumSelected) {
            this.numSelectedChange.emit(numSelected);
            this.prevNumSelected = numSelected;
        }
    };
    AirportFilterListComponent.prototype.getNumSelected = function () {
        if (!this.filterComponents) {
            return 0;
        }
        var selected = this.filterComponents.filter(function (c) { return c.filter.enabled; }).length;
        this._cdRef.detectChanges();
        return selected;
    };
    Object.defineProperty(AirportFilterListComponent.prototype, "fuel100LLFilter", {
        get: function () {
            return this.query.getFilter(FilterKeys.FuelFilter)
                .find(function (f) { return f.fuelType === FuelType._100LL; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AirportFilterListComponent.prototype, "fuelJetAFilter", {
        get: function () {
            return this.query.getFilter(FilterKeys.FuelFilter)
                .find(function (f) { return f.fuelType === FuelType.JetA; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AirportFilterListComponent.prototype, "fuelMOGASFilter", {
        get: function () {
            return this.query.getFilter(FilterKeys.FuelFilter)
                .find(function (f) { return f.fuelType === FuelType.MOGAS; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AirportFilterListComponent.prototype, "fuelUL94Filter", {
        get: function () {
            return this.query.getFilter(FilterKeys.FuelFilter)
                .find(function (f) { return f.fuelType === FuelType.UL94; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AirportFilterListComponent.prototype, "rwyLenFilter", {
        get: function () {
            return this.query.getFilter(FilterKeys.RunwayLength);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AirportFilterListComponent.prototype, "ilsApproachFilter", {
        get: function () {
            return this.query.getFilter(FilterKeys.Approach)
                .find(function (f) { return f.approach === ApproachType.ILS; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AirportFilterListComponent.prototype, "rnavApproachFilter", {
        get: function () {
            return this.query.getFilter(FilterKeys.Approach)
                .find(function (f) { return f.approach === ApproachType.RNAV; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AirportFilterListComponent.prototype, "vorApproachFilter", {
        get: function () {
            return this.query.getFilter(FilterKeys.Approach)
                .find(function (f) { return f.approach === ApproachType.VOR; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AirportFilterListComponent.prototype, "airframeRepairFilter", {
        get: function () {
            return this.query.getFilter(FilterKeys.Services)
                .find(function (f) { return f.service === ServiceType.AirframeRepair; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AirportFilterListComponent.prototype, "engineRepairFilter", {
        get: function () {
            return this.query.getFilter(FilterKeys.Services)
                .find(function (f) { return f.service === ServiceType.EngineRepair; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AirportFilterListComponent.prototype, "avionicsRepairFilter", {
        get: function () {
            return this.query.getFilter(FilterKeys.Services)
                .find(function (f) { return f.service === ServiceType.AvionicsRepair; });
        },
        enumerable: true,
        configurable: true
    });
    AirportFilterListComponent.prototype.fuelChange = function (e, fuelType) {
        this._globalSettingsService.changeFuelType(fuelType);
        if (fuelType === '100LL' && e) {
            this.fuelJetAFilter.enabled = false;
            this.fuelMOGASFilter.enabled = false;
            this.fuelUL94Filter.enabled = false;
        }
        if (fuelType === 'JetA' && e) {
            this.fuel100LLFilter.enabled = false;
            this.fuelMOGASFilter.enabled = false;
            this.fuelUL94Filter.enabled = false;
        }
        if (fuelType === 'MOGAS' && e) {
            this.fuel100LLFilter.enabled = false;
            this.fuelJetAFilter.enabled = false;
            this.fuelUL94Filter.enabled = false;
        }
        if (fuelType === 'UL94' && e) {
            this.fuel100LLFilter.enabled = false;
            this.fuelMOGASFilter.enabled = false;
            this.fuelJetAFilter.enabled = false;
        }
        // this.filtersChange.emit();
        // this._cdRef.detectChanges();
        /* console.log('100LL: ', this.fuel100LLFilter.enabled);
        console.log('JetA: ', this.fuelJetAFilter.enabled);
        console.log('MOGAS: ', this.fuelMOGASFilter.enabled);
        console.log('UL94: ', this.fuelUL94Filter.enabled); */
    };
    return AirportFilterListComponent;
}());
export { AirportFilterListComponent };
